// extracted by mini-css-extract-plugin
export default {"alignSelfStart":"ResourceSelectionButton_alignSelfStart__3-Azd"};